/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { XIcon } from "@heroicons/react/solid";
import { AddCircle as AddIcon } from '@mui/icons-material';
import { Alert, Snackbar } from '@mui/material';

export default function Recipe({ close, type, value }) {

  const vertical = 'bottom';
  const horizontal = 'center';
  const [errorPopUp, setErrorPopUp] = useState(false);
  const tempArr = value?.ingredients;
  const defaultValueArr = [];
  if (tempArr && tempArr.length) {
    tempArr.forEach((a, i) => defaultValueArr.push({
      key: i,
      item_uuid: a.item_uuid || '',
      qty: a.qty || '',
      unit_uuid: a.unit_uuid || '',
      remarks: a.remarks || '',
      ingredient_uuid: a.ingredient_uuid || '',
    }))
  }
  const DEFAULT_VALUES = defaultValueArr.length ? defaultValueArr : [
    {
      key: 0,
      item_uuid: '',
      qty: '',
      unit_uuid: '',
      remarks: '',
      ingredient_uuid: '',
    }
  ];
  const [tableData, setTableData] = useState(DEFAULT_VALUES);
  const [items, setItems] = useState([]);
  const [editValues, setEditValues] = useState(false);

  useEffect(() => {
    const getItems = async () => {
      const json = {
        outlet_uuid: localStorage.getItem("outlet_uuid"),
      }
      const url = `https://api.myfooddo.com/item/ListItem`;
      await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify(json),
      })
        .then(res => res.json())
        .then(data => {
          if (data.length) {
            setItems(data)
          }
        })
        .catch(err => console.warn("post request failed", err));
    }
    getItems();
    // console.log(tableData)
  }, [tableData]);

  useEffect(() => {
    document.addEventListener("keydown", function (event) {
      if (event.keyCode === 13) {
        event.preventDefault();
        addNewRow();
        return false;
      }
    });
  }, []);

  const addNewRow = async () => {
    const arr = tableData;
    arr.push({
      key: tableData.length,
      item_uuid: '',
      qty: '',
      unit_uuid: '',
      remarks: '',
      ingredient_uuid: '',
    });
    setTableData([...arr]);
  }

  const CreateIngredientInDB = async () => {
    const arr1 = [];
    tableData.forEach((a) => {
      if (a.qty && a.item_uuid) {
        arr1.push({
          item_uuid: a.item_uuid,
          qty: a.qty,
          unit_uuid: a.unit_uuid,
          remarks: a.remarks
        })
      }
    })

    if (arr1.length) {
      const json = {
        item_uuid: value.item_uuid,
        ingredients: arr1
      }
      const url = `https://api.myfooddo.com/item/UpdateItemRecipe`;
      // const url = `http://localhost:5000/item/UpdateItemRecipe`;
      console.log(url, json);
      await fetch(url, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify(json),
      })
        .then(res => res.json())
        .then(data => {
          console.log("CreateItemRecipe...", data);
        })
        .catch(err => console.warn("post request failed", err));
    }
  }

  const handleSave = async (e) => {
    e.preventDefault();
    CreateIngredientInDB();
    close();
  }

  return (
    <div className="newCategory" draggable={false}>
      <form className="newCatContainer" action="" onSubmit={handleSave}
        style={{ height: "75vh", maxHeight: "88vh" }}>
        <div className="newCatContainer_header">
          <h2>Recipe</h2>
          <XIcon className="closeicon" onClick={close} />
        </div>
        <div className="items_table" style={{ height: "fit-content", padding: "10px 5px 10px", flex: "1" }}>
          <h3 className="pv1 mb2 tc black-80 fw6" style={{ letterSpacing: '0.05em' }}>
            {`Enter Ingredients for ${value?.units?.find(a => a.unit_is_primary === 'Y')?.unit_name || '-'} of ${value?.item_name || '-'}`}
          </h3>
          <table className="f6 w-100 center" cellSpacing="0">
            <thead className="lh-copy">
              <tr className="white">
                <th className="pa2 bb pl3 tl b--black-20 ">Sr No.</th>
                <th className="pa2 bb pl3 tc b--black-20 ">Item</th>
                <th className="pa2 bb tc b--black-20 ">Quantity</th>
                <th className="pa2 bb tc b--black-20 ">Unit</th>
                <th className="pa2 bb tc b--black-20 ">Remarks</th>
              </tr>
            </thead>
            <tbody className="lh-copy">
              {tableData.length > 0 &&
                tableData?.sort((a, b) => a.key - b.key).map((elem, i) => {
                  return <tr key={i.toString()}>
                    <td className="ph2 pv1 bb b--black-20 tc bg-white">{i + 1}</td>
                    <td className="ph2 pv1 bb b--black-20 tc bg-white">
                      <div className="inputGroup">
                        {/* {(type!=='edit' || editValues)?  */}
                        <Select
                          options={items.map((item, j) => {
                            return {
                              value: item.item_uuid,
                              label: item.item_name,
                              key: j,
                              disabled: i < defaultValueArr.length ? true : tableData.filter((a) => a.item_uuid === item.item_uuid).length
                            }
                          }
                          )}
                          isOptionDisabled={(option) => option.disabled}
                          onChange={(e) => {
                            const x = tableData.filter((a) => +a.key !== +i)
                            let y = tableData.find((a) => +a.key === +i)
                            y.item_uuid = e.value;
                            setTableData([...x, y])
                          }}
                          value={items.filter((a) => a.item_uuid === tableData.find((a) => +a.key === +i).item_uuid)
                            .map((b) => ({ value: b.item_uuid, label: b.item_name })
                            )[0] || null}
                          menuPosition="fixed"
                          menuPlacement="auto"
                          placeholder='Item'
                        />
                        {/* : items.find(a => a.item_uuid===tableData.find((a)=> a.key==i).item_uuid)?.item_name || '-'} */}
                      </div>
                    </td>
                    <td className="ph2 pv1 bb b--black-20 tc bg-white">
                      {/* {(type!=='edit' || editValues)? */}
                      <input
                        id='Quantity'
                        type="number"
                        className='qtyInput'
                        disabled={i < defaultValueArr.length ? true : false}
                        required={tableData.find((a) => +a.key === +i).item_uuid}
                        value={tableData.find((a) => +a.key === +i).qty}
                        onChange={(e) => {
                          const x = tableData.filter((a) => +a.key !== +i);
                          let y = tableData.find((a) => +a.key === +i);
                          y.qty = e.target.value;
                          setTableData([...x, y])
                        }}
                        min={1}
                      />
                      {/* : tableData.find((a)=> a.key==i).qty || '-'} */}
                    </td>
                    <td className="ph2 pv1 bb b--black-20 tc bg-white">
                      {/* {(type!=='edit' || editValues)? */}
                      <select
                        id='Unit'
                        disabled={i < defaultValueArr.length ? true : false}
                        required={tableData.find((a) => +a.key === +i).item_uuid}
                        value={tableData.find((a) => +a.key === +i).unit_uuid}
                        onInvalid={() => {
                          const unitsExist = items?.find(a =>
                            a.item_uuid === tableData.find((a) => +a.key === +i).item_uuid
                          )?.units || [];
                          if (!unitsExist?.length) setErrorPopUp(true)
                        }}
                        onChange={(e) => {
                          const x = tableData.filter((a) => +a.key !== +i);
                          let y = tableData.find((a) => +a.key === +i);
                          y.unit_uuid = e.target.value;
                          setTableData([...x, y])
                        }}
                      > <option key={0} value='' disabled selected>Select Unit</option>
                        {items?.find(a =>
                          a.item_uuid === tableData.find((a) => +a.key === +i).item_uuid
                        )?.units?.map(a =>
                          <option key={a.unit_uuid} value={a.unit_uuid}>{a.unit_name}</option>
                        )}
                      </select>
                      {/* : tableData.find((a)=> a.key==i).unit_uuid || '-'} */}
                    </td>
                    <td className="ph2 pv1 bb b--black-20 tc bg-white">
                      <div className="inputGroup">
                        {/* {(type!=='edit' || editValues)? */}
                        <input
                          placeholder="Remarks..."
                          type="text"
                          maxLength="200"
                          disabled={i < defaultValueArr.length ? true : false}
                          value={tableData.find((a) => +a.key === +i).remarks}
                          onChange={(e) => {
                            const x = tableData.filter((a) => +a.key !== +i)
                            let y = tableData.find((a) => +a.key === +i)
                            y.remarks = e.target.value;
                            setTableData([...x, y])
                          }}
                        />
                        {/* : tableData.find((a)=> a.key==i).remarks || '-'} */}
                      </div>
                    </td>
                  </tr>
                })}
              <tr>
                <td onClick={addNewRow}>
                  <AddIcon sx={{ fontSize: 40 }} style={{ color: '#4AC959', cursor: 'pointer' }} />
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <Snackbar
          open={errorPopUp}
          anchorOrigin={{ vertical, horizontal }}
          autoHideDuration={3000}
          onClose={() => setErrorPopUp(false)}
          style={{ bottom: '10px', left: 'calc(50% + 80px)' }}
        >
          <Alert
            onClose={() => setErrorPopUp(false)}
            severity="error"
            variant="filled"
            style={{ fontWeight: 'bold', letterSpacing: '1px', background: 'red' }}
          >
            Please create at least one unit for this item.
          </Alert>
        </Snackbar>

        <div className="bottomContent">
          {type === "edit" && !editValues ? (
            <button
              onClick={(e) => {
                e.preventDefault();
                setEditValues(true);
                return false;
              }}
            >
              Edit
            </button>
          ) : (
            <button type="submit">Save</button>
          )}
        </div>
      </form>
    </div>
  );
}